import { GetServerSideProps } from 'next';
import { LandingPageComponent } from 'src/components/landingpage';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

/**
 * Page Component
 */

export default function LandingPage() {
  return <LandingPageComponent />;
}

/**
 * Export `getServerSideProps`.
 */

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  return {
    props: {
      hideLayout: true,
      ...(await serverSideTranslations(locale ?? 'pt', ['landingpage']))
    }
  };
};
